/*
 * File: index.ts
 * File Created: 2024-02-02 07:43:38
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2025-12-11 08:43:14
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

// import { ALLOW_GENERAL_MODIFY, ALLOW_GENERAL_READ } from "@/helpers/permission-helper";
import { PARAMS_INCLUDE, PARAMS_WHERE } from "@/views/core";
import { IPermissionCheck, ObjectHelper, Vue } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";
// import { ETranslationJobRolePermission } from "shared-taiwan-bank-life-insurance";
const _ = UIQuick.getInstance;

// const rolePermission: ETranslationJobRolePermission = ETranslationJobRolePermission.系統維護管理作業;

@UIQuick.set()
export class TranslationJob extends IQuickUnit {
    title = "w_MenuTranslation";
    path = "/translation-job";
    icon = "fa-solid fa-earth-asia";

    /// hireachy
    parents = () => [_`Organization`];
    children = null;

    /// file
    file = ["inputFile", "outputFile"];

    /// params
    paramsWhere = PARAMS_INCLUDE;
    paramsRead = function (this: IQuickUnit) {
        return ObjectHelper.deepMerge(
            {
                orderBy: [
                    {
                        createdAt: "desc",
                    },
                ],
            },
            PARAMS_INCLUDE,
        );
    };
    paramsUpdate = PARAMS_INCLUDE;

    /// interfaces
    infDetail = require("raw-loader!./interfaces/translation-job.create.interface")
        .default;
    infRead = require("raw-loader!./interfaces/translation-job.read.interface").default;
    infCreate = require("raw-loader!./interfaces/translation-job.create.interface")
        .default;
    infUpdate = require("raw-loader!./interfaces/translation-job.create.interface")
        .default;
    infDelete = require("raw-loader!./interfaces/translation-job.delete.interface")
        .default;
}
